import Checkbox from '../forms/Checkbox';
import React, { Component } from 'react';
import CategoryBadge from '../CategoryBadge';
import Input from '../forms/Input';

class CategoryConfigRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            position: props.item.position ?? 0
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item?.id !== this.props.item?.id || prevProps.item?.position !== this.props.item?.position) {
            this.setState({ position: this.props.item.position ?? 0 });
        }
    }

    _toggleSelect = () => this.props.onSelect(this.props.item.id, this.props.item);

    _open = e => {
        if (e.target.type === 'checkbox') {
            return null;
        }
        return this.props.allowOpen && this.props.onOpen(this.props.item);
    };

    _renderLabels = () => {
        const labels = this.props.item.labels || [];
        return (
            <div className="ckp-clearing-badges" style={{ flexWrap: 'nowrap' }}>
                {labels.map((label, index) => (
                    <CategoryBadge key={index} label={label.label} color={label.color} showHidden={true} />
                ))}
            </div>
        );
    };

    _renderVisibility = () => {
        const visibleInViews = this.props.item.visibleInViews;
        const visibilityText = visibleInViews.join(', ');
        return <span>{visibilityText}</span>;
    };

    _handlePositionChange = value => {
        this.setState({ position: value });
        if (this.props.onPositionChange) {
            this.props.onPositionChange(this.props.item, parseInt(value));
        }
    };

    _handlePositionClick = e => {
        e.stopPropagation();
    };

    _getPositionError = () => {
        const positionValue = this.state.position;
        if (positionValue === '' || positionValue === null || positionValue === undefined) {
            return 'Required';
        }
        return null;
    };

    _renderPosition = () => {
        const errorMessage = this._getPositionError();
        return (
            <Input
                type="number"
                value={String(this.state.position)}
                onChange={this._handlePositionChange}
                onClick={this._handlePositionClick}
                className="ckp-label-text-input"
                errorMessage={errorMessage}
                regex={/^[0-9]+$/}
                min="0"
            />
        );
    };

    render() {
        const blocked = !(this.props.enableRowFunction && this.props.enableRowFunction(this.props.item));
        const selectBlocked = !(this.props.enableSelectFunction && this.props.enableSelectFunction(this.props.item));

        return (
            <tr
                className={`ckp-tables-body-row ${blocked ? 'is-blocked' : ''} ${
                    this.props.allowOpen && !blocked ? 'is-clickable' : ''
                }`}
            >
                {this.props.selectable ? (
                    <td className="ckp-tables-select-column">
                        {blocked || selectBlocked ? null : (
                            <Checkbox
                                checked={this.props.selected}
                                name={this.props.item.id}
                                onChange={this._toggleSelect}
                            />
                        )}
                    </td>
                ) : null}
                <td className="ckp-tables-rest-column" onClick={this._open}>
                    <div className="ckp-tables-body-column u-truncate">{this.props.item.label}</div>
                    <div className="ckp-tables-body-column">{this._renderVisibility()}</div>
                    <div className="ckp-tables-body-column">{this._renderPosition()}</div>
                    <div>{this._renderLabels()}</div>
                </td>
            </tr>
        );
    }
}

CategoryConfigRow.defaultProps = { allowOpen: true };

export default CategoryConfigRow;
